import React, { useContext } from 'react';
import Container from 'shared/container';
import Headline from 'shared/headline';
import Img from 'shared/img';
import Icon from 'shared/icon';
import { layoutContext } from 'context/layout-provider';
import { qualityColor, numberKorM } from 'utils/helpers';
import s from './hero.module.scss';
import StickyImg from '../stats-section/stickies/img';
import StickyDetails from '../stats-section/stickies/details';

function calculateTrueValue(total, rate) {
  let number = total * (rate);
  if (number.toFixed(0).toString().length > 6) {
    number = `${(number / 1000000).toFixed(1)}M`;
  } else if (number.toFixed(0).toString().length > 3) {
    number = `${(number / 1000).toFixed(1)}K`;
  }
  // return number.replace('.0', '');
  return number.toString().replace('.0', '');
}

function NumberDisplay({ number, display }) {
  return (
    <div className={s.displayWrapper}>
      <div className={s.number}>
        {typeof number === 'string' ? number : number.toFixed()}
      </div>
      <div className={s.display}>{display}</div>
    </div>
  );
}

function QualityBox({ quality }) {
  const dashedO = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="28"
      viewBox="0 0 18 28"
      style={{ overflow: 'visible' }}
    >
      <defs>
        <style
          type="text/css"
          dangerouslySetInnerHTML={{
            __html: `
          @import
          url('https://fonts.googleapis.com/css?family=Suranna');
          tspan{
            font-family: 'Suranna', serif!important;
            font-size: 37.605px;
            letter-spacing: -0.02em;
          }
          `
          }}
        />
      </defs>
      <g id="Group_53" data-name="Group 53" transform="translate(-922.455 -96)">
        <text id="o" transform="translate(922.455 122)" fill="#fff">
          <tspan x="0" y="0">
            o
          </tspan>
        </text>
        <path
          id="Path_17"
          data-name="Path 17"
          d="M931.156,162.8a.75.75,0,0,1-.807-.676V139.554a.82.82,0,0,1,1.614,0v22.573A.75.75,0,0,1,931.156,162.8Z"
          transform="translate(0 -36.396)"
          fill="#fff"
        />
      </g>
    </svg>
  );
  return (
    <div className={`${s.qualityBox} ${s[qualityColor(quality)]}`}>
      <span className={s.qualityNumber}>{quality}</span>
      <span className={s.totalNumber}>of 100</span>
    </div>
  );
}

function InfluencersHero({
  firstName,
  lastName,
  username,
  globalRank,
  countryRank,
  qualityScore,
  avgLikes,
  avgComments,
  engagementRate,
  authenticityRate,
  country,
  category,
  featuredImage,
  images,
  categoryRank,
  followers = 'MISSING',
  stickyDetails,
  ...props
}) {
  const layout = useContext(layoutContext);
  const { displaySize: screenWidth } = layout;
  const countryName = country && country.name;
  return (
    <>
      <div className={s.sImgWrapper}>
        <StickyImg img={featuredImage?.id || 'placeholder-dark'} mobile />
      </div>
      <Container className={s.root}>
        <div className={s.bgOverlay} />
        <div className={s.backgroundWrapper}>
          <Img
            className={s.bgImg}
            src={(images && images[0]?.id) || 'placeholder-dark'}
          />
        </div>
        <div className={s.sImgWrapper}>
          <StickyImg img={featuredImage?.id || 'placeholder-dark'} tablet />
        </div>
        <StickyDetails details={stickyDetails} tablet />
        <div className={s.floatRightHalfContainer}>
          <Headline h2 className={s.influencerName}>
            {`${firstName} ${lastName}`}
          </Headline>
          {countryName && (
            <div className={s.location}>
              <Icon icon="location" />
              {countryName}
            </div>
          )}
          <div
            className={`${s.userDetails} ${countryName ? s.hasCountry : ''}`}
          >
            <a
              className={s.username}
              href={`https://www.instagram.com/${username.replace('@', '')}/`}
            >
              <Icon icon="instagram" />
              {username}
            </a>
            <span>
              Followers
              <strong>{numberKorM(followers)}</strong>
            </span>
            <span>
              Averages
              <strong>
                <Icon icon="heart" />
                {avgLikes}
                <Icon icon="comments" />
                {avgComments}
              </strong>
            </span>
          </div>

          <div className={s.numbersContainer}>
            <NumberDisplay
              number={calculateTrueValue(followers, authenticityRate)}
              display="true followers"
            />
            <NumberDisplay
              number={calculateTrueValue(followers, engagementRate)}
              display="true fans"
            />
            <QualityBox quality={qualityScore} color={category?.name} />
          </div>
        </div>
      </Container>
      {screenWidth === 'MOBILE' ? (
        <StickyDetails details={stickyDetails} />
      ) : null}
    </>
  );
}
export default InfluencersHero;
